import Announcement from '../chat/components/Announcement';
import Conversation from '../chat/components/Conversation';
import './style.scss';
import { RootState } from '@/typings';
import { useSelector } from 'react-redux';
import { ElScrollbar } from '@qsxy/element-plus-react';

const Home = () => {
	// const { data = [], loading } = useRequest(fetchSystemList);
	// const [showChart, setShowChart] = useState(false);
	const loginUser = useSelector<RootState, RootState['user']>(state => state.user ?? {});

	return (
		<ElScrollbar>
			<div className="ttn-home-container">
				<div className="ttn-w900">
					<Announcement />
					<div className="ttn-welcome"> 👋 Hello {loginUser?.isVisitor ? '游客' + loginUser?.username.substring(0, 5) : loginUser?.username}</div>

					<Conversation />
				</div>
			</div>
		</ElScrollbar>
	);
};

export default Home;
